<template>
	<div class="p-2" id="dreams_log_button">
		<div class="row">
			<div class="col-12 mb-2">
				<b-input-group>
					<b-form-input v-model="search_text" placeholder="Search dreams..."></b-form-input>
					<b-input-group-append>
						<b-button variant="outline-primary" class="m-0" @click="dreamsGet('search')">
							<i class="fas fa-search"></i>
						</b-button>
						<b-button variant="outline-secondary" class="m-0" @click="dreamsGet('latest')">
							<i class="fas fa-times"></i>
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</div>

			<div v-if="readonly == 0" class="col-12 mb-2 text-left">
				<b-button variant="outline-primary" @click="openModal">
					<i class="fas fa-cloud-meatball fa-1x"></i> Log My Dream
				</b-button>
			</div>
		</div>

		<div v-if="searching == 1" class="text-muted">
			<i class="fas fa-atom fa-spin"></i> searching
		</div>

		<div v-if="dreams !== null && dreams.length > 0" class="text-left">
			<b-list-group v-for="(dream, index) in dreams" :key="'dream-' + index">
				<b-list-group-item
					@click="viewDream(dream)"
					class="d-flex justify-content-between align-items-center mb-1 small pointer"
				>
					<div>
						<i
							v-if="dream.has_new_comment == 1"
							class="fas fa-comment-dots fa-flip-horizontal fa-2x mr-2 text-danger"
						></i>
						<span v-text="dream.title"></span>
					</div>
					<small class="gold" style="min-width: 80px">
						<b v-text="dream.date_human"></b>
					</small>
				</b-list-group-item>
			</b-list-group>
		</div>
		<div v-else>
			<p class="text-muted text-center">No dreams found</p>
		</div>

		<b-modal id="dream_wrapper" title="Log my Dream" size="lg" ref="mobileViewHack">
			<div class="row">
				<div class="col-12 mb-2" ref="title">
					<p class="p-0 m-0 mt-3"><b>Title</b></p>
					<div v-if="readonly == 0">
						<small
							class="text-danger"
							v-if="errors.title !== ''"
							v-text="errors.title"
						></small>
						<b-form-input
							id="elm_title"
							v-model="dream_title"
							placeholder="Title for your dream"
							@focus="focusInput('title')"
						></b-form-input>
					</div>
					<div v-else v-text="dream_title"></div>
				</div>

				<div class="col-12 mb-2" ref="date" v-if="modal_status === 'edit'">
					<p class="p-0 m-0 mt-3"><b>Date</b></p>
					<div v-text="date_human"></div>
				</div>

				<div class="col-12 mb-2" ref="text">
					<p class="p-0 m-0 mt-3"><b>What happened in your dream?</b></p>
					<div v-if="readonly == 0">
						<small class="text-danger" v-if="errors.text !== ''" v-text="errors.text"></small>
						<b-form-textarea
							id="elm_text"
							v-model="dream_text"
							placeholder="What do you remember?"
							rows="10"
							max-rows="12"
							class="mt-2"
							:state="dream_text.length >= 10"
							@focus="focusInput('text')"
						></b-form-textarea>
					</div>
					<div v-else v-html="dream_text"></div>
				</div>

				<div
					v-if="
						(active_dream.youtube && active_dream.youtube.length > 0) ||
						(active_dream.vimeo && active_dream.vimeo.length > 0)
					"
					class="col-12 mb-2"
				>
					<video-embeds :embeddata="active_dream" classW="" show_title="0" />
				</div>

				<div class="col-12 mb-2 border-top">
					<div v-if="readonly == 0">
						<p class="p-0 m-0 mt-3 col-12"><b>Privacy</b></p>
						<div class="col-12">
							<b-form-checkbox v-model="dream_comments" switch>
								Comments - <small>turned on, comments are active</small>
							</b-form-checkbox>
						</div>
					</div>
					<div v-else class="text-right">
						<p class="p-0 m-0 mt-3 col-12"><b>Privacy</b></p>
						Comments: <b v-text="dream_comments"></b><br />
					</div>
				</div>

				<div v-if="dream_replies" class="col-12 pt-2 mb-4 border-top">
					<h5 class="gold">Replies</h5>

					<div
						v-for="R in dream_replies"
						:key="R.id"
						:class="'R_' + R.id"
						class="mb-4 pb-2 border-bottom"
					>
						<div class="row">
							<div class="col-md-12">
								<p class="small">
									<i class="fas fa-user"></i>
									<span v-text="R.user_name"></span><br />
									<i class="far fa-clock"></i>
									<span v-text="R.access.date"></span> -
									<span v-text="R.access.time" class="mr-2"></span>
								</p>
								<p>
									<b v-text="R.title"></b>
								</p>
								<div>
									<span v-html="R.main_text"></span>
								</div>
							</div>
						</div>

						<div
							v-if="(R.youtube && R.youtube.length > 0) || (R.vimeo && R.vimeo.length > 0)"
							class=""
						>
							<video-embeds :embeddata="R" classW="col-md-6 mb-2" />
						</div>
					</div>
				</div>

				<div v-if="readonly == 1" class="col-12 mb-2 mt-2 border-top">
					<p class="p-0 m-0 mt-3"><b>Comments/Reply</b></p>
					<b-form-textarea
						v-model="dream_reply"
						placeholder="Add your comment/reply here"
						rows="6"
						max-rows="10"
						class="mt-2"
					></b-form-textarea>
					<b-button size="sm" variant="primary" @click="replyAdd()"> Add Comment </b-button>
				</div>
			</div>

			<template #modal-footer="{ ok, cancel }">
				<div>
					<!--
					<div class="">
						<ul
							class="list-group list-group-flush text-danger"
							v-for="(error, index) in errors"
							:key="'E' + index"
						>
							<li class="list-group-item p-0" v-if="error !== ''" v-text="error"></li>
						</ul>
					</div>
				-->

					<div v-if="readonly == 0">
						<button
							type="button"
							class="btn btn-primary"
							@click="Submit()"
							:disabled="!can_submit"
						>
							<i class="fas fa-cloud-meatball fa-1x"></i>
							<span v-if="modal_status == 'add'">Log</span><span v-else>Edit</span> Dream
						</button>

						<b-button
							v-if="modal_status === 'edit'"
							size="sm"
							variant="outline-danger"
							@click="remove()"
						>
							<i class="fas fa-trash-alt"></i> Delete
						</b-button>
						<b-button size="sm" variant="outline-secondary" @click="cancel()">
							Close
						</b-button>
					</div>
					<div v-else>
						<b-button size="sm" variant="outline-secondary" @click="cancel()">
							Close
						</b-button>
					</div>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import axios from 'axios';
import VideoEmbeds from '../components/VideoEmbeds.vue';
import {strUtils} from '../components/FormVaildation';
import EventBus from "@/bus";

export default {
	name: 'DreamsLog',
	components: {
		VideoEmbeds,
	},
	props: {
		userid: {
			type: Number,
			default: null,
		},
		limit: {
			type: Number,
			default: 14,
		},
		readonly: {
			type: Number,
			default: 1,
		},
	},
	data() {
		const now = new Date();
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const maxDate = new Date(today);

		return {
			active_dream: [],
			can_submit: false,
			date: '',
			date_human: '',
			date_status: false,
			dreams: [],
			dream_comments: true,
			dream_readonly: 1,
			dream_reply: '',
			dream_replies: {},
			dream_text: '',
			dream_title: '',
			date_max: maxDate,
			errors: {
				date: '',
				text: '',
				title: '',
			},
			modal_status: 'add',
			search_text: '',
			searching: 1,
			screenHeight: screen.availHeight,
		};
	},
	computed: {},
	methods: {
		checkSubmit() {
			console.log('checkSubmit');

			if (this.date === '') {
				this.date_status = false;
			} else {
				this.date_status = true;
			}

			if (!strUtils.isEmpty(this.dream_title) && !strUtils.isEmpty(this.dream_text) && !strUtils.tooShort(this.dream_text,10) && this.date_status === true) {
				this.can_submit = true;
			} else {
				this.can_submit = false;
			}
		},

		dreamsGet(type) {
			console.log('dreamsGet:');
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', this.$store.state.session_id);
			params.append('readonly', this.readonly);

			if (this.userid !== null) {
				params.append('user_id', this.userid);
			}

			params.append('category', 'dreams');
			params.append('limit', this.limit);
			params.append('order_by', 'access');
			params.append('order_direction', 'desc');
			params.append('type', 'edit');

			if (type == 'search') {
				params.append('search_text', _this.search_text);
			}

			this.dreams = [];
			this.search_text = '';
			this.searching = 1;

			axios({
				url: _this.$store.state.api_url + 'dreamsGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.dreams && response.data.dreams !== null) {
						let entries = Object.values(response.data.dreams);
						_this.dreams = entries;

						_this.$store.commit('layoutCardClassSet', {
							col_type_class: 'row-cols-1 row-cols-md-1',
						});
					}

					_this.searching = 0;
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		focusInput(elm) {
			console.log(elm);
			let _this = this;
			setTimeout(function () {
				_this.$refs[elm].scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'start',
				});
			}, 1000);
			/*console.log(this.$refs[elm]);*/
		},

		viewDream(dream) {
			if (dream.has_new_comment == 1) {
				this.mark_dream_viewed(dream);
			}

			this.active_dream = dream;
			this.dream_title = this.active_dream.title;
			this.dream_text = this.active_dream.main_text;
			this.date = this.active_dream.date_edit;
			this.date_human = this.active_dream.date_human;
			this.dream_comments = this.active_dream.can_comment;
			this.dream_readonly = this.active_dream.readonly;
			this.dream_replies = this.active_dream.replies;
			this.modal_status = 'edit';
			this.checkSubmit();
			this.$bvModal.show('dream_wrapper');
		},

		mark_dream_viewed(dream) {
			dream.has_new_comment = 0;
			let _this = this;
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('forum_id', dream.id);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'forumRepliesViewed',
				data: params,
			})
				.then(function () {})
				.catch(function (error) {
					console.log(error);
				});
		},

		openModal() {

			console.log('openModal');
			this.active_dream = [];
			this.date = (new Date).toISOString().split('T')[0];
			this.dream_text = '';
			this.dream_title = '';
			this.modal_status = 'add';
			this.checkSubmit();
			this.$bvModal.show('dream_wrapper');
		},

		replyAdd() {
			console.log('replyAdd');
			let _this = this;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('main_text', _this.dream_reply);
			params.append('post_id', _this.active_dream.id);
			params.append('view_user_id', _this.userid);

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'dreamReply',
				data: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						_this.$bvModal.hide('dream_wrapper');
						_this.dream_reply = '';
						_this.dreamsGet('latest');
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},

		remove() {
			console.log('Remove');
			var c = confirm('Are you sure!');
			if (c === true) {
				let _this = this;

				let params = new URLSearchParams();
				params.append('token', _this.$store.state.session_id);
				params.append('forum_id', _this.active_dream.id);

				axios({
					method: 'post',
					url: _this.$store.state.api_url + 'dreamRemove',
					data: params,
				})
					.then(function () {
						_this.$bvModal.hide('dream_wrapper');
						_this.dreamsGet('latest');
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		},

		Submit() {
			console.log('Submit');
			this.checkSubmit();

			if (this.can_submit == false) {
				return false;
			}

			let _this = this;

			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			params.append('date', _this.date);
			params.append('dream_text', _this.dream_text);
			params.append('dream_title', _this.dream_title);
			params.append('dream_comments', _this.dream_comments);

			if (_this.modal_status == 'edit') {
				params.append('forum_id', _this.active_dream.id);
			}

			axios({
				method: 'post',
				url: _this.$store.state.api_url + 'dreamAdd',
				data: params,
			})
				.then(function () {
					_this.$bvModal.hide('dream_wrapper');
					_this.dreamsGet('latest');
				})
				.catch(function (error) {
					console.log(error);
				});
		},
	},
	created() {
		EventBus.$on('showDreamLogPopup', this.openModal)
	},
	mounted() {
		console.log(screen.availHeight);
		this.dreamsGet('latest');
	},
	beforeDestroy() {
		EventBus.$off('showDreamLogPopup', this.openModal)
	},
	watch: {
		dream_text: {
			immediate: true,
			handler(val) {
				if (!strUtils.isEmpty(val) && !strUtils.tooShort(val,10)) {
					this.errors.text = '';
				} else {
					this.errors.text = 'What do you remember? (min 10 characters)';
				}
				this.checkSubmit();
			},
		},
		dream_title: {
			immediate: true,
			handler(val) {
				if (!strUtils.isEmpty(val)) {
					this.errors.title = '';
				} else {
					this.errors.title = 'Give this dream a title...';
				}
				this.checkSubmit();
			},
		},
		date: {
			immediate: true,
			handler(val) {
				if (val !== null && val !== '') {
					this.errors.date = '';
				} else {
					this.errors.date = 'What date was your dream?';
				}
				this.checkSubmit();
			},
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
